import config from 'config';
import { BUSINESS_UNITS } from 'core/domains';
import { select } from 'core/middlewares/utilities';
import { OldHistory } from 'ui/components/History';

import { redirectLogin } from './redirect-login';
import { checkAndRemoveCyclesCache } from '../../helpers';

import type { RootState } from 'core/store';

export function* redirectFlow() {
  const resellerId: RootState['user']['data']['resellerId'] = yield select(
    ({ user }) => user.data.resellerId,
  );

  const isResaleIntention: RootState['user']['data']['isResaleIntention'] = yield select(
    (rootState: RootState) => rootState.user.data.isResaleIntention,
  );

  const isAutoStartEnabled: RootState['user']['data']['isAutoStartEnabled'] = yield select(
    (rootState: RootState) => rootState.user.data.isAutoStartEnabled,
  );

  const isEud = config.app.short === BUSINESS_UNITS.EUD.toLowerCase();

  if (!isEud) {
    if (isResaleIntention && !isAutoStartEnabled && !localStorage.getItem('is-ir')) {
      OldHistory.navigate('/intencao-de-revenda');

      return;
    }

    if (isResaleIntention && !isAutoStartEnabled) {
      return;
    }
  }

  const cycles: RootState['user']['data']['avaliableCycles'] = yield select(
    ({ user }) => user.data.avaliableCycles,
  );

  const isExtendedCaptation = cycles.canChooseCycle;
  const canBuyOnlyInER = cycles.canBuyOnlyInER;

  const hasNotChosenCycle =
    !localStorage.getItem(`choose-extended-cycle-${resellerId}`) &&
    !localStorage.getItem(`choose-new-cycle-${resellerId}`);

  const isInExtendedCapationAndHasNotChosenCycle = isExtendedCaptation && hasNotChosenCycle;
  // const isNotAllowedToRedirect = new RegExp(
  //   MF_SELF_SERVICE_ROUTES.INCENTIVES_CAMPAIGN.split('/')[1],
  // ).test(location.pathname);

  if (canBuyOnlyInER || isInExtendedCapationAndHasNotChosenCycle) {
    // if (!isNotAllowedToRedirect) {
    OldHistory.navigate('/ciclo-estendido');

    return;
    // }
  }

  checkAndRemoveCyclesCache(isExtendedCaptation, resellerId);

  yield redirectLogin();
}
